import React from "react";

// Summary cards for one employee over the filtered date range

const fmt = (n) => n.toFixed(1).replace(".0", "");

const CARDS = [
  ["totalDays", "Total Days", "bg-blue-50 border-blue-100", "text-blue-600", "text-blue-800"],
  ["workingDays", "Working Days", "bg-indigo-50 border-indigo-100", "text-indigo-600", "text-indigo-800"],
  ["approved", "Approved Leaves", "bg-green-50 border-green-100", "text-green-600", "text-green-800"],
  ["pending", "Pending Leaves", "bg-yellow-50 border-yellow-100", "text-yellow-600", "text-yellow-800"],
  ["rejected", "Rejected Leaves", "bg-red-50 border-red-100", "text-red-600", "text-red-800"],
  ["absent", "Absent", "bg-gray-100 border-gray-200", "text-gray-700", "text-gray-900"],
];

const LeaveStats = ({ stats }) => (
  <div className="grid grid-cols-6 gap-4 mb-6 text-center">
    {CARDS.map(([key, label, box, labelColor, valueColor]) => (
      <div key={key} className={`${box} p-4 rounded-lg border shadow-sm`}>
        <div className={`text-sm ${labelColor} font-semibold mb-1`}>{label}</div>
        <div className={`text-2xl font-bold ${valueColor}`}>
          {key === "totalDays" ? stats.totalDays : fmt(stats[key])}
        </div>
      </div>
    ))}
  </div>
);

export default LeaveStats;
